/*
 * AUTO-GENERATED FILE. DO NOT MODIFY
 *
 * This file was automatically generated by the
 * npm run generate-design-token command, and it
 * should not be modified by hand.
 */

export const ButtonBaseSizeSmallHeight = '32px'
export const ButtonBaseSizeSmallMinWidth = '40px'
export const ButtonBaseSizeMediumHeight = '40px'
export const ButtonBaseSizeMediumMinWidth = '48px'
export const ButtonBaseSizeLargeHeight = '48px'
export const ButtonBaseSizeLargeMinWidth = '56px'
export const ButtonBaseBorderRadiusLarge = '6px'
export const ButtonBaseBorderRadiusMedium = '5px'
export const ButtonBaseBorderRadiusSmall = '4px'
export const ButtonBaseSpacingIconOffSmallLeft = '8px'
export const ButtonBaseSpacingIconOffSmallRight = '8px'
export const ButtonBaseSpacingIconOffMediumLeft = '16px'
export const ButtonBaseSpacingIconOffMediumRight = '16px'
export const ButtonBaseSpacingIconOffLargeLeft = '16px'
export const ButtonBaseSpacingIconOffLargeRight = '16px'
export const ButtonBaseSpacingIconLSmallLeft = '4px'
export const ButtonBaseSpacingIconLSmallRight = '8px'
export const ButtonBaseSpacingIconLSmallGap = '4px'
export const ButtonBaseSpacingIconLMediumLeft = '12px'
export const ButtonBaseSpacingIconLMediumRight = '16px'
export const ButtonBaseSpacingIconLMediumGap = '12px'
export const ButtonBaseSpacingIconLLargeLeft = '12px'
export const ButtonBaseSpacingIconLLargeRight = '16px'
export const ButtonBaseSpacingIconLLargeGap = '12px'
export const ButtonBaseSpacingIconRSmallLeft = '8px'
export const ButtonBaseSpacingIconRSmallRight = '4px'
export const ButtonBaseSpacingIconRSmallGap = '4px'
export const ButtonBaseSpacingIconRMediumLeft = '16px'
export const ButtonBaseSpacingIconRMediumRight = '12px'
export const ButtonBaseSpacingIconRMediumGap = '12px'
export const ButtonBaseSpacingIconRLargeLeft = '16px'
export const ButtonBaseSpacingIconRLargeRight = '12px'
export const ButtonBaseSpacingIconRLargeGap = '12px'
